function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSecure = function SvgSecure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m12.1 1-9 4v6c0 5.5 3.8 10.7 9 12 5.2-1.3 9-6.5 9-12V5Z",
    transform: "translate(-.1)",
    style: {
      fill: "#0a1343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.914-2.818a1.7 1.7 0 0 1-.949 1.588A1.991 1.991 0 0 1 6.756.457a1.876 1.876 0 0 1-.806 1.608 3.731 3.731 0 0 1-2.224.583 3.857 3.857 0 0 1-2.346-.627A2.127 2.127 0 0 1 .539.205L2.232.2a.936.936 0 0 0 .375.8 1.868 1.868 0 0 0 1.119.278 1.846 1.846 0 0 0 1-.22.672.672 0 0 0 .34-.589.715.715 0 0 0-.378-.621 6.065 6.065 0 0 0-1.451-.536 6.867 6.867 0 0 1-1.611-.618 2.279 2.279 0 0 1-.809-.762 2.007 2.007 0 0 1-.266-1.061 1.741 1.741 0 0 1 .949-1.6 2 2 0 0 1-.8-1.687 1.925 1.925 0 0 1 .823-1.617 3.633 3.633 0 0 1 2.227-.615 3.417 3.417 0 0 1 2.244.662 2.261 2.261 0 0 1 .8 1.84H5.1a1.038 1.038 0 0 0-.36-.823 1.454 1.454 0 0 0-.987-.313 1.825 1.825 0 0 0-1 .229.711.711 0 0 0-.352.627.724.724 0 0 0 .325.645 5.583 5.583 0 0 0 1.409.5 7.3 7.3 0 0 1 1.655.609 2.271 2.271 0 0 1 .847.771 2.026 2.026 0 0 1 .277 1.083Zm-4.23-1.307a.87.87 0 0 0-.439.826.8.8 0 0 0 .243.624 2.888 2.888 0 0 0 .97.454l1.3.393a.889.889 0 0 0 .48-.82.752.752 0 0 0-.267-.595 3.022 3.022 0 0 0-.958-.466Z",
    transform: "translate(8.461 14.648)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.1 0h24v24H.1V0Z",
    transform: "translate(-.1)",
    style: {
      fill: "none"
    }
  }));
};
export default SvgSecure;